<template>
  <div class="Offers">
    <menuBox :step="4"></menuBox>
    <div class="top-box">
      <div class="top-title">Target</div>
      <div class="top-content">
        PT JASINDO CITRA MAJU / Target
      </div>
    </div>
    <div class="Offers-text-box">
      <div class="item">
        <img src="../assets/offer-icon-1.png" alt="" />
        <div class="content">
          <div class="title">Manfaat komunitas</div>
          <div class="msg">
            Memberikan pelayanan kesejahteraan yang menyeluruh dengan tujuan meningkatkan kesejahteraan anggota masyarakat.
          </div>
        </div>
      </div>
      <div class="item">
        <img src="../assets/offer-icon-2.png" alt="" />
        <div class="content">
          <div class="title">promosi kesehatan
        </div>
          <div class="msg">
            Mempromosikan kesadaran kesehatan masyarakat dan melaksanakan pendidikan kesehatan dan program kesehatan preventif.
          </div>
        </div>
      </div>
      <div class="item">
        <img src="../assets/offer-icon-3.png" alt="" />
        <div class="content">
          <div class="title">dukungan ketenagakerjaan</div>
          <div class="msg">
            Memberikan pelatihan ketenagakerjaan dan dukungan pengembangan karir kepada penyandang disabilitas dan kelompok kurang beruntung.
          </div>
        </div>
      </div>
      <div class="item">
        <img src="../assets/offer-icon-4.png" alt="" />
        <div class="content">
          <div class="title">inovasi teknologi</div>
          <div class="msg">
            Mengoptimalkan proses pelayanan melalui inovasi teknologi dan meningkatkan efisiensi dan kualitas layanan.
          </div>
        </div>
      </div>
      <div class="item">
        <img src="../assets/offer-icon-5.png" alt="" />
        <div class="content">
          <div class="title">jaringan kerjasama</div>
          <div class="msg">
            Membangun kemitraan dengan bisnis lokal dan LSM untuk mendorong pengembangan masyarakat.
          </div>
        </div>
      </div>
      <div class="item">
        <img src="../assets/offer-icon-6.png" alt="" />
        <div class="content">
          <div class="title">
            pembangunan berkelanjutan</div>
          <div class="msg">
            Mencapai pembangunan bisnis berkelanjutan jangka panjang dan menjamin kesinambungan dan stabilitas layanan.
          </div>
        </div>
      </div>
    </div>
    <div class="offers-list">
      <div class="title">
        Dalam persiapan
      </div>
      <div class="mission-msg">
        <img class="msg" src="../assets/offer-1.png" alt="" />
        <div class="msg-box">
          <div class="msg-title">
            Program Asuransi Kesehatan Anak
          </div>
          <div class="msg-content">
            PT Jasindo Citra Maju sedang mempersiapkan proyek keamanan medis anak-anak yang bertujuan membantu anak-anak dari keluarga kurang mampu secara ekonomi menerima dukungan medis yang diperlukan. Proyek ini akan memberikan bantuan keuangan kepada anak-anak yang tidak mampu membayar perawatan medis untuk memastikan bahwa mereka menerima pengobatan yang tepat waktu dan efektif. Tujuan kami adalah mengurangi beban keuangan keluarga, meningkatkan kesehatan anak-anak, dan menciptakan kondisi yang lebih baik untuk pertumbuhan mereka. Melalui proyek ini kami berharap dapat memberikan kontribusi positif terhadap kesehatan dan kesejahteraan masyarakat.
          </div>
          <div class="btn" @click="goPage()">
            Hubungi kami
          </div>
        </div>
        <img class="process" src="../assets/process.png" alt="" />
      </div>
    </div>
    <footerBox ref="footerBox"></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: { goPage() {
      this.$refs.footerBox.selectMenu(5);
    },},
};
</script>
<style lang="less" scoped>
.top-box {
  height: 60px;
  background: #ce3723;
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-title {
    font-size: 24px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #ffffff;
    line-height: 29px;
  }
  .top-content {
    font-size: 14px;
    font-family: Inter, Inter;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}
.Offers-text-box {
  padding: 40px 360px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    img {
      width: 20px;
      height: 20px;
    }
    .content {
      max-width: 250px;
      margin-left: 50px;
      .title {
        font-size: 16px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #1e1e1e;
        line-height: 19px;
      }
      .msg {
        font-size: 12px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #959595;
        line-height: 14px;
        margin-top: 16px;
      }
    }
  }
}
.about-title {
  background-image: url(../assets/about-1.png);
  width: 100%;
  height: 320px;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  font-weight: 500;
  color: #333333;
}

.Offers-text {
  padding: 80px 360px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;

  p {
    text-indent: 2em;
    margin-top: 28px;
    span {
      color: #b043fc;
    }
  }
}

.offers-list {
  padding: 0 360px;
  height: 524px;
  background: #f2f2f2;
  overflow: hidden;
  .title {
    font-size: 32px;
    font-family: Inter, Inter;
    font-weight: normal;
    color: #1e1e1e;
    line-height: 38px;
    text-align: center;
    margin-top: 80px;
    margin-bottom: 32px;
  }
  .mission-msg {
    height: 300px;
    background-color: #fff;
    .msg {
      height: 100%;
      float: left;
    }
    .process {
      float: left;
      width: 180px;
      height: 180px;
      margin-top: 57px;
      margin-left: 30px;
    }
    .msg-box {
      margin-left: 40px;
      max-width: 580px;
      float: left;
      .msg-title {
        font-size: 20px;
        font-family: Inter, Inter;
        font-weight: normal;
        color: #1e1e1e;
        line-height: 24px;
        margin-top: 20px;
      }
      .msg-content {
        font-size: 14px;
        font-family: Inter, Inter;
        font-weight: 400;
        color: #959595;
        line-height: 16px;
        margin-top: 16px;
      }
      .btn {
        width: 136px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        background: #ce3723;
        border-radius: 30px;
        margin-top: 20px;
      }
    }
  }
}
</style>
